import type { Language } from '../../i18n/translations.js';
import { DEMO_COPY } from './demo-copy.js';
export function DemoSignup({
  language,
  onRequestAccess,
}: {
  readonly language: Language;
  readonly onRequestAccess: (from: HTMLElement) => void;
}) {
  const c = DEMO_COPY[language];
  return (
    <>
      <section
        className="wrap waitlist closing-cta"
        id="waitlist"
        aria-labelledby="waitlist-title"
      >
        <div className="closing-atmosphere" aria-hidden="true">
          <i />
          <i />
          <i />
          <i />
        </div>
        <div className="waitlist-copy">
          <h2 id="waitlist-title">
            <span>{c.nextStep}</span>
            <br />
            <span>{c.withYou}</span>
          </h2>
          <p className="closing-support">{c.pilotContact}</p>
        </div>
        <div className="waitlist-entry">
          <button
            type="button"
            className="btn"
            onClick={(event) => {
              onRequestAccess(event.currentTarget);
            }}
          >
            <span className="cs-px3" aria-hidden="true">
              <i />
              <i />
              <i />
            </span>
            {c.joinLabel}
            <span className="arrow" aria-hidden="true">
              →
            </span>
          </button>
          <p className="access-note">{c.generationClosed}</p>
        </div>
      </section>
      <footer className="wrap footer">
        <a
          href="#main"
          aria-label={language === 'ar' ? 'موجة — الرئيسية' : 'Mouja home'}
        >
          <img
            className="logo"
            src={
              language === 'ar'
                ? '/mouja-arabic-pixel-media-logo.svg'
                : '/mouja-pixel-media-logo.svg'
            }
            alt=""
            width="102"
            height="28"
          />
        </a>
        <a className="text-btn" href="#main">
          {c.backToTop}
        </a>
      </footer>
    </>
  );
}
